import { Link, useParams } from 'react-router-dom';
import SaleMainSection from '@/partials/sale/sale-main-section';
import ProductsSection from '@/partials/sale/products-section';
import ScopeTab from '@/partials/sale/scope-tab';
import { useSaleScope } from '@/hooks/sale/use-sale-scope';
import { SaleStatus } from '@/types/api/sale';
import { useAuth } from '@/hooks/auth/use-auth';
import { Button } from '@/shared/components/ui/button';
import { PlusCircle } from 'lucide-react';
import { useModal } from '@/hooks/shared/use-modal';
import { ModalType } from '@/types/stores/modal';
// @ts-ignore
import SalesIcon from '@/images/sales-icon.svg?react';
import { MembershipRole } from '@/types/api/membership';
import { useSaleSuspense } from '@/features/sales/api/get-sale';
import { useParticipation } from '@/features/participations/api/get-participation';
import { paths } from '@/config/paths';
import { ReferralCard } from '@/features/sales/components/referral-card';

export default function Sale() {
  const { open } = useModal();
  const context = useAuth().context!;
  const saleId = useParams().saleId!;
  const { isParticipationScope } = useSaleScope();
  const { data: sale } = useSaleSuspense({ saleId, params: { include: ['products'] } });
  const { data: participation } = useParticipation({
    saleId,
    userId: context.userId,
    params: { include: ['products'] },
    queryConfig: { retry: false },
  });

  const own = isParticipationScope && participation ? participation : null;
  const items = own ? own.items : sale.items;
  const profit = own ? own.profit : sale.profit;
  const unitCount = own ? own.unitCount : sale.unitCount;
  const unitCountTarget = own ? own.unitCountTarget : sale.unitCountTarget;

  return (
    <>
      <div className="flex justify-between items-center mb-5">
        {/* Left: Title */}
        <div className="flex items-center gap-2">
          <h1 className="text-2xl md:text-3xl text-gray-800 dark:text-gray-100 font-bold">Översikt</h1>
        </div>

        {/* Right: Title */}
        <div>
          {sale.status !== SaleStatus.Active && context.membershipRoles.includes(MembershipRole.Leader) && (
            <Button asChild>
              <Link to={paths.sales.create.getHref()}>
                <PlusCircle aria-hidden="true" /> Starta ny försäljning
              </Link>
            </Button>
          )}
        </div>
      </div>

      {participation && <ScopeTab />}

      <div className="grid grid-cols-6 gap-4">
        <SaleMainSection
          {...sale}
          profit={profit!}
          unitCount={unitCount!}
          unitCountTarget={unitCountTarget!}
          // The breakdown and steps are for the whole group's sale, not a seller's share.
          groupSale={own ? undefined : sale}
          profitLabel={own ? 'Din vinst' : 'Gruppens vinst'}
        />

        {/* The code is the whole group's, so it's not in a seller's own view. */}
        {!own && <ReferralCard sale={sale} />}

        <ProductsSection items={items} />
      </div>
    </>
  );
}
